import { ReactNode } from "react";

import { EntityAttribute } from "shared/api/api";
import { AllAttributesResponse } from "shared/api/attributes/api";
import { M2MRelationshipsGroupBy } from "shared/schemas/types";

export interface ContextWrapComponentProps {
  children: ReactNode;
}

export type ContextWrapper = React.FC<ContextWrapComponentProps>;

export enum ContextProviderName {
  Claim = "claim",
  CustomRecord = "customRecord",
  CustomSignalEventDefinition = "customSignalEventDefinition",
  Dealer = "dealer",
  Directive = "directive",
  Eval = "eval",
  FailureMode = "failureMode",
  FailureModeEvents = "failureModeEvent",
  Inspection = "inspection",
  InspectionItem = "inspectionItem",
  Issue = "issue",
  Repair = "repair",
  RepairVerification = "repairVerification",
  RepairPart = "repairPart",
  RepairLabor = "repairLabor",
  RepairPartVerification = "repairPartVerification",
  RepairLaborVerification = "repairLaborVerification",
  RiskModelPrediction = "riskModelPrediction",
  Run = "run",
  Schedule = "schedule",
  SensorReading = "sensorReading",
  SignalEventOccurrence = "signalEventOccurrence",
  Vehicle = "vehicle",
  VehicleECU = "vehicleECU",
  VehicleOption = "vehicleOption",
  VehiclePart = "vehiclePart",
  ServiceCenters = "serviceCenters",
  WorkOrder = "workOrder",
  WorkOrderVerification = "workOrderVerification",
  WorkOrderParts = "workOrderPart",
  Part = "part",
  Labor = "labor",
  ServiceRecord = "serviceRecord",
  NotesVerification = "notesVerification",
  Asset = "asset",
  ManufactureLineExit = "manufactureLineExit",
  ServiceCenterV2 = "serviceCenterV2",
  WorkOrderVerificationV2 = "workOrderVerificationV2",
  RepairPartVerificationV2 = "repairPartVerificationV2",
  RepairLaborVerificationV2 = "repairLaborVerificationV2",
  NotesVerificationV2 = "notesVerificationV2",
  WorkOrderV2 = "workOrderV2",
  WorkOrderPartsV2 = "workOrderPartV2",
  RepairV2 = "repairV2",
  RepairVerificationV2 = "repairVerificationV2",
  RepairPartV2 = "repairPartV2",
  RepairLaborV2 = "repairLaborV2",
  VMRSV2 = "vmrsV2",
  SensorReadingV2 = "sensorReadingV2",
  KnowledgeItem = "knowledgeItem",
  KnowledgeSourceDocument = "knowledgeSourceDocument",
}

export type ContextName =
  (typeof ContextProviderName)[keyof typeof ContextProviderName];

export type AttributesContextContent = {
  attributes: EntityAttribute[] | undefined;
  groupByValues: M2MRelationshipsGroupBy;
};

export type GroupByRelationIDValues = Record<
  ContextName,
  M2MRelationshipsGroupBy
>;

export interface AllAttributesContextType {
  groupByValues: GroupByRelationIDValues;
  attributes: AllAttributesResponse;
}
